import { FacebookIcon, TwitterIcon } from "next-share";
import { AUTHOR_SOCIAL_LINK_CLICKED } from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import CopyUrlButton from "./CopyUrlButton";
import styles from "./authorSocialLinks.module.scss";

export type AuthorSocialLinksProps = {
  dispatchFunction: () => void;
  facebookUrl?: string;
  twitterUrl?: string;
  authorName?: string;
};

const AuthorSocialLinks = (props: AuthorSocialLinksProps) => {
  const { dispatchFunction, facebookUrl, twitterUrl, authorName } = props;
  const { logAmplitudeEvent } = useAmplitude();
  const trackSocialLinkClick = (linkText: string) => {
    logAmplitudeEvent(AUTHOR_SOCIAL_LINK_CLICKED, {
      Author: authorName ?? "",
      "Link Text": linkText,
      Module: "author_header",
    });
  };

  return (
    <div className={styles.container}>
      {facebookUrl && (
        <a
          data-testid="facebook-link"
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackSocialLinkClick("facebook")}
        >
          <FacebookIcon size={24} round />
        </a>
      )}
      {twitterUrl && (
        <a
          data-testid="twitter-link"
          href={twitterUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackSocialLinkClick("twitter")}
        >
          <TwitterIcon size={24} round />
        </a>
      )}
      <CopyUrlButton dispatchFunction={dispatchFunction} />
    </div>
  );
};

export default AuthorSocialLinks;
